import {
  EuiButton,
  EuiFlexGroup,
  EuiFlexItem,
  EuiPopover,
  EuiSelectable,
  EuiSelectableOption,
  EuiSpacer,
} from "@inscopix/ideas-eui";
import { TableIcon } from "components/ProjectTablesTable/TableIcon";
import { useWorkflowEditorContext } from "components/WorkflowEditor/WorkflowEditorProvider/WorkflowEditorProvider";
import { sortBy } from "lodash";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";

export const WorkflowEditorAddTablePopover = () => {
  const selectedTableKeys = useWorkflowEditorContext((s) =>
    s.tableInfo.map((t) => t.tableKey),
  );
  const allAnalysisTables = useDataTableContext((s) =>
    sortBy(
      s.tables.filter((t) => t.kind === "analysis"),
      (t) => t.date_created,
    ),
  );

  const updateTableList = useWorkflowEditorContext((s) => s.updateTableList);

  const [isAddTableOpen, setIsAddTableOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [options, setOptions] = useState<
    EuiSelectableOption<{ key: string }>[]
  >(
    allAnalysisTables.map((t) => {
      return {
        key: t.id,
        label: `${t.name} (${t.key})`,
        prepend: <TableIcon tableType={t.kind} />,
        checked: selectedTableKeys.includes(t.key)
          ? ("on" as const)
          : undefined,
      };
    }),
  );

  const handleConfirm = async () => {
    setIsLoading(true);
    const { error } = await updateTableList(
      options.filter((o) => o.checked === "on").map((o) => o.key),
    );
    if (error !== undefined) {
      addUtilityToastFailure(error);
    } else {
      addUtilityToastSuccess("Successfully added tables");
      setIsAddTableOpen(false);
    }
    setIsLoading(false);
  };

  return (
    <EuiPopover
      anchorPosition="leftUp"
      // closing controlled by buttons
      closePopover={() => undefined}
      isOpen={isAddTableOpen}
      button={
        <EuiButton
          iconType="plusInCircle"
          onClick={() => setIsAddTableOpen(true)}
          size="s"
        >
          Add/Remove Tables
        </EuiButton>
      }
    >
      <EuiSelectable
        css={{ minWidth: 500 }}
        aria-label="Select Analysis Tables"
        searchable
        options={options}
        onChange={(newOptions) => {
          setOptions(newOptions);
        }}
      >
        {(list, search) => (
          <>
            {search}
            {list}
          </>
        )}
      </EuiSelectable>
      <EuiSpacer />
      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiButton isLoading={isLoading} onClick={() => void handleConfirm()}>
            Confirm
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiButton color="accent" onClick={() => setIsAddTableOpen(false)}>
            Cancel
          </EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiPopover>
  );
};
